import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";
import VueGtag from 'vue-gtag'
import "../config/Variable.js";

//Pages
import Home from "../pages/Home.vue";
import AboutUs from "../pages/AboutUs.vue";
import VisiMisi from "../pages/VisiMisi.vue";
import InfoAntrian from "../pages/InfoAntrian.vue";
import InfoAntrianBed from "../pages/InfoAntrianBed.vue";
import Fasilitas from "../pages/Fasilitas.vue";
import FasilitasDetail from "../pages/FasilitasDetail.vue";
import Contact from "../pages/Contact.vue";
import Asuransi from "../pages/Asuransi.vue";
import AsuransiDetail from "../pages/AsuransiDetail.vue";
import Kegiatan from "../pages/Kegiatan.vue";
import JadwalDokter from "../pages/JadwalDokter.vue";
import Berita from "../pages/Berita.vue";
import BeritaDetail from "../pages/BeritaDetail.vue";
import Tv from "../pages/Tv.vue";
import Karir from "../pages/Karir.vue";
import RSPilihan from "../pages/RSPilihan.vue";
import TipsTrik from "../pages/TipsTrik.vue";
import TipsTrikDetail from "../pages/TipsTrikDetail.vue";
import Login from "../pages/Login.vue";
import Register from "../pages/Register.vue";
import Verification from "../pages/Verification.vue";
import Appointment from "../pages/Appointment.vue";
import AppointmentMiddleware from "../pages/AppointmentMiddleware.vue";
import CariDokter from "../pages/CariDokter.vue";
import DetailDokter from "../pages/DetailDokter.vue";
import PageDetail from "../pages/PageDetail.vue";
import Promo from "../pages/PaketPromo.vue";

Vue.use(Router);
Vue.use(Meta);
Vue.use(VueGtag, {
    config: {
        // id: 'UA-171644270-1',
        id: 'G-3YCTCC7NSM',
        send_page_view: true,
        demographics: {
          enabled: true,
        },
    }
});

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
        },
        {
            path: "/about-us",
            name: "about-us",
            component: AboutUs,
        },
        {
            path: "/visi-misi",
            name: "visi-misi",
            component: VisiMisi,
        },
        {
            path: "/info-antrian",
            name: "info-antrian",
            component: InfoAntrian,
        },
        {
            path: "/info-bed",
            name: "info-bed",
            component: InfoAntrianBed,
        },
        {
            path: "/paket-promo",
            name: "paket-promo",
            component: Promo,
        },
        {
            path: "/layanan-diagnostic/:slug",
            name: "layanan-diagnostic-detail",
            component: FasilitasDetail,
        },
        {
            path: "/fasilitas",
            name: "fasilitas",
            component: Fasilitas,
        },
        {
            path: "/fasilitas/:id",
            name: "fasilitas-detail",
            component: FasilitasDetail,
        },
        {
            path: "/asuransi",
            name: "asuransi",
            component: Asuransi,
        },
        {
            path: "/asuransi/:id",
            name: "asuransi-detail",
            component: AsuransiDetail,
        },
        {
            path: "/jadwal-dokter",
            name: "jadwal-dokter",
            component: JadwalDokter,
        },
        {
            path: "/kesan-spesial",
            name: "kesan-spesial",
            component: Contact,
        },
        {
            path: "/galeri",
            name: "galeri",
            component: Kegiatan,
        },
        {
            path: "/berita",
            name: "berita",
            component: Berita,
        },
        {
            path: "/berita/:search",
            name: "berita-search",
            component: Berita,
        },
        {
            path: "/berita/detail/:slug",
            name: "berita-detail",
            component: BeritaDetail,
        },
        {
            path: "/tv-uii",
            name: "tv",
            component: Tv,
        },
        {
            path: "/rs-uii-pilihan",
            name: "rs-uii-pilihan",
            component: RSPilihan,
        },
        {
            path: "/karir",
            name: "karir",
            component: Karir,
        },
        {
            path: "/tips-trik",
            name: "tips-trik",
            component: TipsTrik,
        },
        {
            path: "/tips-trik/detail",
            name: "tips-trik-detail",
            component: TipsTrikDetail,
        },
        {
            path: "/login",
            name: "login",
            component: Login,
        },
        {
            path: "/sign-up",
            name: "register",
            component: Register,
        },
        {
            path: "/verification",
            name: "verification",
            component: Verification,
        },
        {
            path: "/appointment",
            name: "appointment",
            component: Appointment,
        },
        {
            path: "/appointment/middleware/:action",
            name: "appointment-middleware",
            component: AppointmentMiddleware,
        },
        {
            path: "/cari-dokter",
            name: "cari-dokter",
            component: CariDokter,
        },
        {
            path: "/detail-dokter/:id",
            name: "detail-dokter",
            component: DetailDokter,
        },
        {
            path: "/page/:slug",
            name: "page",
            component: PageDetail,
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js